<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditInfoForm" :rules="addEditInfoRules" ref="addEditBasicForm" label-width="100px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="出生日期" prop="">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditInfoForm.service_personnel_birth_date" :clearable="false"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="身份证号" prop="service_personnel_identity_card_number">
          <el-input v-model="addEditInfoForm.service_personnel_identity_card_number" placeholder="请输入员工身份证号"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="民族" prop="">
          <el-select v-fixZoom v-model="addEditInfoForm.service_personnel_ethnic" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in nationOptions" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="户籍地址" prop="">
          <el-input v-model="addEditInfoForm.service_personnel_household_address" placeholder="如：XX省XX市"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="现居住址" prop="">
          <el-input v-model="addEditInfoForm.service_personnel_contact_address" placeholder="如：XX省XX市XX区XX街道"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="政治面貌" prop="">
          <el-select v-fixZoom v-model="addEditInfoForm.service_personnel_political_status_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in politicalArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="文化程度" prop="">
          <el-select v-fixZoom v-model="addEditInfoForm.service_personnel_cultural_degree_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in educationArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="岗位类型" prop="">
          <el-select v-fixZoom v-model="addEditInfoForm.service_personnel_job_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in jobCodeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="岗位性质" prop="">
          <el-select v-fixZoom v-model="addEditInfoForm.service_personnel_job_nature_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in jobNatureCodeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="入职时间" prop="">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditInfoForm.entry_date" :clearable="false"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="离职时间" prop="">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditInfoForm.service_personnel_departure_date" :clearable="false"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditBasicForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {updateserviceperson} from '../../../api/yanglaoyuan'

export default {
  name: 'detailsInfo',
  props: {
    infoObj: {
      type: Object,
      default: null
    }
  },
  data () {
    const validateIdCard = (rule, value, callback) => {
      const sfz = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value !== '') {
        if (!sfz.test(value)) {
          callback(new Error('身份证输入格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      nationOptions: [],
      politicalArr: [],
      educationArr: [],
      jobCodeArr: [],
      jobNatureCodeArr: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      pickerOptions1: {},
      addEditInfoForm: {
        service_personnel_identity_card_number: '',
        service_personnel_ethnic: '',
        service_personnel_birth_date: '',
        service_personnel_contact_address: '',
        service_personnel_cultural_degree_code: '',
        service_personnel_political_status_code: '',
        entry_date: '',
        service_personnel_departure_date: '',
        service_personnel_household_address: '',
        service_personnel_job_code: '',
        service_personnel_job_nature_code: ''
      },
      addEditInfoRules: {
        service_personnel_identity_card_number: [{ required: false, trigger: 'blur', validator: validateIdCard }],
        service_personnel_ethnic: [{required: true, message: '请选择性别', trigger: 'change'}]
      }
    }
  },
  created () {
    this.politicalArr = this.commonType.getPoliticalArr()
    this.nationOptions = this.commonType.getNationName()
    this.educationArr = this.commonType.getEducationArr()
    this.jobCodeArr = this.commonType.getJobCodeArr()
    this.jobNatureCodeArr = this.commonType.getJobNatureCodeArr()
    this.addEditInfoForm = this.infoObj.formServicePerson
    if (this.addEditInfoForm.service_personnel_birth_date === '0000-00-00') {
      this.addEditInfoForm.service_personnel_birth_date = ''
    }
    if (this.addEditInfoForm.entry_date === '0000-00-00') {
      this.addEditInfoForm.entry_date = ''
    }
    if (this.addEditInfoForm.service_personnel_departure_date === '0000-00-00') {
      this.addEditInfoForm.service_personnel_departure_date = ''
    }
    if (this.addEditInfoForm.id === 0) {
      this.$message({
        message: '请先添加员工基本信息。',
        type: 'warning'
      })
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('changeEndInfo', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditInfoForm.id === 0) {
            this.$message({
              message: '请先添加员工基本信息。',
              type: 'warning'
            })
            return
          }
          updateserviceperson(this.addEditInfoForm).then(res => {
            let obj = {
              type: 'isBtnInfo',
              form: this.addEditInfoForm
            }
            this.$emit('changeEndInfo', obj)
            this.$notify({title: '成功', message: '成功编辑员工', type: 'success', duration: 2000})
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/detailsInfo.vue